// extracted by mini-css-extract-plugin
module.exports = {"promotion-form-table":"promotion-form-table-9f817557d4c85f434c334f808b9dc330","has-list-add-button":"has-list-add-button-93f34bbb7fd94e2f5a08a6bdd86a5c15"};